import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { useLoading } from '@frontend-shared/loading'

import PageLoader from '../../components/PageLoader'

export default function RouteLoadingFallback() {
  const { t } = useTranslation()
  const { startLoading, stopLoading } = useLoading()
  const tokenRef = useRef<string | null>(null)

  useEffect(() => {
    tokenRef.current = startLoading({
      label: t('common.loading'),
      source: 'route',
      type: 'route-chunk',
    })
    return () => {
      if (tokenRef.current) {
        stopLoading(tokenRef.current)
      }
    }
  }, [startLoading, stopLoading, t])

  return <PageLoader />
}
